import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface RightOfUseAssetsRommsProps {
  onBack?: () => void;
}

export default function RightOfUseAssetsRomms({ onBack }: RightOfUseAssetsRommsProps) {
  const workspace = "Right-of-Use Assets";

  return (
    <PayrollRomms
      onBack={onBack || (() => {})}
      onComplete={() => {}}
      workspace={workspace}
    />
  );
}
